import React from 'react';

export interface UserAccountContextProps {
  isProspect: boolean;
  isClient: boolean;
  saveIsProspect(value: boolean): void;
  saveIsClient(value: boolean): void;
}

const UserAccountContext = React.createContext<UserAccountContextProps>(null);

export default UserAccountContext;
